class MeowcartCustomCodeGenerator {
	constructor() {
	}

	generateBarCode(token) {
		const options = {
			bcid: 'code128', // Barcode type
			text: token, // Text to encode
			scale: 3, // 3x scaling factor
			height: 10, // Bar height, in millimeters
			includetext: false, // Show human-readable text
			textxalign: 'center', // Always good to set this
		};
		
		let canvas = document.createElement('canvas');

		try {
            bwipjs.toCanvas(canvas, options);
            return canvas.toDataURL('image/png');
        } catch (e) {
            console.error("Error generating code:", e); 
            return null;
        }
	}

	generateQRCode(token) {
		const options = {
			bcid: 'qrcode', // Barcode type
			text: token, // Text to encode
			scale: 20, // 3x scaling factor
			includetext: false, // Show human-readable text
			textxalign: 'center', // Always good to set this
		};
	
        let canvas = document.createElement('canvas');

		try {
            bwipjs.toCanvas(canvas, options);
            return canvas.toDataURL('image/png');
        } catch (e) {
            console.error("Error generating code:", e); 
            return null;
        }
	}
}